import React from 'react/addons';
import AutoPrefix from 'utils/auto-prefix';
import Extend from 'utils/extend';

/**
 *  @params:
 *  styles = Current styles.
 *  props = New style properties that will override the current style.
 */
export default {

  propTypes: {
    style: React.PropTypes.object
  },

  mergeStyles() {
    let args = Array.prototype.slice.call(arguments, 0);
    let base = args[0];
    for (let i = 1; i < args.length; i++) {
      if (args[i]) base = Extend(base, args[i]);
    }
    return base;
  },


  /** 
   * m loops through all properties defined in the first argument, so overrides
   * of undefined properties will not take place.
   */
  mergeAndPrefix() {
    let args = Array.prototype.slice.call(arguments, 0);

    let base = args[0];
    for (let i = 1; i < args.length; i++) {
      if (args[i]) base = Extend(base, args[i]);
    }

    return AutoPrefix.all(base);
    // return function(args){
    //   return AutoPrefix.all()
    // }.bind()
    },
}


/** WEBPACK FOOTER **
 ** ./src/mixins/js/StylePropable.js
 **/